<template>
  <div class="manage-content">
    <el-dialog title="添加员工" :visible.sync="dialogFormVisible" width="30%">
      <el-form ref="addForm" :model="form" :rules="rules" v-if="this.list.length <= 1">
        <el-form-item prop="name">
          <el-input v-model="form.name" placeholder="请输入员工姓名"></el-input>
        </el-form-item>
        <el-form-item prop="mobile">
          <el-input v-model="form.mobile" placeholder="请输入手机号码"></el-input>
        </el-form-item>
      </el-form>
      <span class="tips">温馨提示：输入的手机号码将作为运营人员的登录账号，请确认输入的是正确的手机号码</span>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addAccount('addForm')">确 定</el-button>
      </div>
    </el-dialog>
    <div class="location">企业管理中心 / 运营账号</div>
    <div class="white-bg shadow margin-top-20 padding30 radius">
      <el-table
              :data="list"
              style="width: 100%">
        <el-table-column
                prop="name"
                label="员工姓名"
                width="180">
        </el-table-column>
        <el-table-column
                prop="mobile"
                label="手机号码"
                width="180">
        </el-table-column>
        <el-table-column
                label="操作">
          <template slot-scope="scope">
            <el-button size="small" @click="delAccount(scope.row.mobile)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button type="primary" style="margin-top:30px;" @click="dialogFormVisible = true" v-if="this.list.length <= 1">添加员工</el-button>
<!--      <div class="manage-title margin-bottom-20" v-if="this.list.length <= 1"><em class="txt">添加员工</em><span class="tips">温馨提示：输入的手机号码将作为运营人员的登录账号，请确认输入的是正确的手机号码</span></div>-->
<!--      <el-form ref="addForm" :model="form" :rules="rules" label-width="80px" v-if="this.list.length <= 1">-->
<!--        <el-form-item label="员工姓名" prop="name">-->
<!--          <el-input v-model="form.name" placeholder="请输入员工姓名"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="手机号码" prop="mobile">-->
<!--          <el-input v-model="form.mobile" placeholder="请输入手机号码"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item>-->
<!--          <el-button type="primary" @click="addAccount('addForm')">添加员工</el-button>-->
<!--        </el-form-item>-->
<!--      </el-form>-->
    </div>
  </div>
</template>
<script>
import {accountList,addAccount,delAccount} from '@/config/api.js';
const checkPhone = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('手机号不能为空'));
  } else {
    const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/;
    if (reg.test(value)) {
      callback();
    } else {
      return callback(new Error('请输入正确的手机号'));
    }
  }
};
export default {
  name: 'EnterpriseAccount',
  inject:['reload'],
  data () {
    return {
      tableData: [{
        date: '刘慧婷',
        name: '13411261765'
      }, {
        date: '2016-05-04',
        name: '13411261765'
      }, {
        date: '2016-05-01',
        name: '13411261765'
      }, {
        date: '2016-05-03',
        name: '13411261765'
      }],
      form: {
        name: '',
        tel: ''
      },
      list: [],
      dialogFormVisible: false,
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        mobile: [
          {required: true,validator: checkPhone, trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    getAccountList () {
      let data = {
        user_type: 0,
        user_id: this.$store.state.user_id
      };
      this.$post(accountList,data)
              .then(res => {
                this.list = res.data;
              })
              .catch(err => {
                window.console.log(err)
              })
    },
    addAccount (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            user_type: 0,
            user_id: this.$store.state.user_id,
            name:this.form.name,
            mobile: this.form.mobile
          };
          this.$post(addAccount,data)
                  .then(() => {
                    this.getAccountList();
                    this.dialogFormVisible = false;
                    setTimeout(() => {
                      this.$message.success('您已成功添加运营账号');
                    },200);
                    this.form.name = null;
                    this.form.mobile = null;
                  })
                  .catch(err => {
                    this.$message.error(err.msg)
                  })
        } else {
          return false;
        }
      });
    },
    delAccount (mobile) {
      this.$confirm('账号删除后，将无法登录进行操作，是否继续?', '删除运营账号', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = {
          user_type: 0,
          mobile: mobile,
        };
        this.$post(delAccount,data)
                .then(() => {
                  this.getAccountList();
                  setTimeout(() => {
                    this.$message.success('成功删除数据');
                  },200)
                })
                .catch(err => {
                  this.$message.error(err.msg)
                })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    }
  },
  mounted() {
    this.getAccountList()
  }
}
</script>
<style scoped>
  .manage-title{margin-top:40px;}
  .tips{color:#999;font-size: 12px;margin-left: 10px;}
</style>
